import React from 'react';
import { withRouter } from '../../withRouter';

const AlertToastTemplate = (props) => {
    const { className = '', history, roomInfo, alarmName } = props;

    return (
        <div
            className={className}
            onClick={() => {
                history.push('/allRoomEvents');
            }}
        >
            <h5>{roomInfo?.name}</h5>
            {alarmName}
        </div>
    );
};

export default withRouter(AlertToastTemplate);
